export default __webpack_public_path__ + "static/media/Certificate_BHS.4919d327.pdf";